import { buttonStyle, commonStyles } from "src/Library/CommonStyles";

export const FFConnectionRequestKYCStyles = (theme) => ({
  modal: {
    '& .ant-modal-body': {
      color: theme.colors.textSecondary,
      fontSize: '12px',
      padding: '14px 24px 50px 24px',
    },
    '& .ant-modal-footer': {
      borderTop: 0,
    },
  },
  okButton: {
    ...buttonStyle(theme.colors.bgWhite, theme.colors.primaryDark, `1px solid ${theme.colors.primaryDark}`),
    borderRadius: '3px',
    marginLeft: '24px',
  },
  skipButton: {
    color: theme.colors.textTertiary,
    cursor: 'pointer',
    fontWeight: 600,
  },
  editKyc: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: '12px',
  },
  modifyKYC: {
    marginLeft: '8px',
    cursor: 'pointer',
    fontSize: '10px',
    color: theme.colors.primaryDark,
  },
  nonLinkedFFsText: {
    fontWeight: 600,
    marginBottom: '12px',
    fontSize: '14px',
  },
  nonLinkedFFDiv: {
    margin: '18px 0',
  },
  ffList: {
    ...commonStyles(theme).justifySpaceBetween,
    margin: '10px 0',
  },
  kycModal: {
    minWidth: '1000px',
    '& .ant-modal-title': {
      fontWeight: 'bold',
    },
    '& .ant-modal-body': {
      padding: '36px 24px',
      color: theme.colors.textSecondary,
      fontSize: '12px',
    },
  },
  enterKYCText: {
    fontSize: '16px',
    fontWeight: 600,
  },
  kycText: {
    marginTop: '8px',
    color: theme.colors.textTertiary,
    fontSize: '10px',
  },
  secureData: {
    backgroundColor: '#E6F3F0',
    borderRadius: '24px',
    fontSize: '12px',
    fontWeight: 600,
    padding: '9px 21px',
    float: 'right',
    ...commonStyles(theme).flexRow,
  },
  input: {
    fontSize: '12px',
    width: 'auto !important',
    minWidth: '53% !important',
  },
  formInput: {
    marginBottom: '8px',
    '& .has-error .ant-form-explain,': {
      fontSize: '10px',
    },
  },
  datePicker: {
    minWidth: '20% !important',
    '& .ant-calendar-picker-input.ant-input': {
      fontSize: '12px',
    },
  },
  disclaimer: {
    fontSize: '14px',
    fontWeight: 600,
    // overflow: 'hidden',
    // WebkitLineClamp: 5,
    // WebkitBoxOrient: 'vertical',
  },
  dateAndUsername: {
    ...commonStyles(theme).justifySpaceBetween,
  },
  skipModal: {
    '& .ant-modal-body': {
      color: theme.colors.textSecondary,
    },
    '& .ant-modal-footer': {
      borderTop: 0,
    },
  },
  secureDataImg: {
    height: '24px',
    width: '21px',
    marginRight: '8px',
  },
  showAll: {
    color: theme.colors.primary,
    cursor: 'pointer',
    marginBottom: '8px',
    textDecoration: 'underline',
    float: 'right',
  },
});
